/**
 * batch-67 meldingen-ontvangers (FO-500 §C7) - aanvullende labels voor
 * doelgroep-resolvers.
 *
 * Sinds FO-500 staat onder elke melding "Waarom: je hoort bij de doelgroep ...".
 * Een kale sleutel (`leave.requester`) is daar onleesbaar voor een monteur. Deze
 * kaart vult aan wat `SELECTABLE_RECIPIENT_RESOLVERS` en
 * `RESOLVER_WEERGAVE_LABELS` (notification-rules.ts) nog niet benoemen;
 * `resolverLabel()` leest alle drie.
 *
 * Bewust een EIGEN bladmodule: de bestaande kaart is een plek waar elke batch
 * regels onderaan toevoegt, en een tweede blok daar geeft een merge-conflict.
 *
 * De drift-test `resolver-indeling-drift.test.ts` (apps/api) faalt op een
 * geregistreerde resolver zonder label en noemt de sleutel. Een label is een
 * zelfstandig-naamwoordgroep die past achter "je hoort bij de doelgroep ...".
 */
export const AANVULLENDE_RESOLVER_LABELS: Readonly<Record<string, string>> = {
  'leave.requester': 'De aanvrager van het verlof',
  'all-vertrouwenspersonen': 'Vertrouwenspersonen',
  'employee.self+salaris': 'Medewerker + salarisadministratie',
  'cert.betrokkenen': 'De medewerker en de verantwoordelijke van het certificaat',
  'cert.hr+verantwoordelijke': 'HR en de verantwoordelijke van het certificaat',
  'acquisitie.checkin-verantwoordelijke': 'De verantwoordelijke van de check-in',
  'acquisitie.vervolg-eigenaar': 'De eigenaar van de leads',
  'verjaardag.teamleider': 'Teamleider van de jarige medewerker',
  'configurable.recipients': 'Ingestelde ontvangers van deze melding',
  'consignatie.ruil-collega+planner': 'De collega van de ruil en de planners',
  'consignatie.ruil-aanvrager+planner': 'De aanvrager van de ruil en de planners',
  'consignatie.ruil-aanvrager+collega': 'De aanvrager en de collega van de ruil',
  'relatie-onboarding.beoordelaars': 'Beoordelaars van de relatie-onboarding',
  'vervanging.opvolgers': 'Wie de vervanging regelt (teamleider, planners)',
  'uitrusting.verwerkers': 'Verwerkers van uitrustingbestellingen',
  'uitrusting.picklijst': 'Magazijn en verwerkers van uitrusting',
  'loonstrook.beheerders': 'Loonstrook-beheerders',
  'loonstrook.verzoek-beoordelaars': 'Beoordelaars van loonstrook-verzoeken',
  'taak.escalatie': 'Teamleider van de uitvoerder en de escalatie-ontvanger van de takenmodule',
  'taak.escalatie-aanmaker': 'Teamleider, escalatie-ontvanger en de aanmaker van de taak',
  'taak.aanmaker': 'De aanmaker van de taak',
  'reisuren.teamleider': 'Teamleider van de medewerker',
  'idee.reactie-teamleider': 'Teamleider van de reagerende medewerker',
  'uitrusting.levering.beoordelaar': 'Wie de bestelling goedkeurde',
  'kluis.eigenaar': 'De eigenaar van het geheim',
  'kluis.vrijgave.beoordelaars': 'Beoordelaars van de vrijgave (eigenaar en beheerders)',
  'kluis.vrijgave.betrokkenen': 'De aanvrager en de eigenaar van het geheim',
  // batch-69 werkbon-pauze (FO-511, integrator-review H1)
  'klantpauze.oplossers':
    'Wie de pauzeregel van de klant kan bevestigen (Relaties bewerken) of de factuurpauze kan herstellen (werkbon-facturatie)',
  // De resolvers van de andere batch-67-streams. Ze bestaan op deze branch nog
  // niet; een label dat (nog) nergens bij hoort is onschuldig.
  'campagne.beheerders': 'Beoordelaars van de campagne',
  'campagne.deelnemer': 'De deelnemer aan de campagne',
  'evenement.organisatie': 'Organisatie van het evenement',
  'hr-besluit.behandelaars': 'HR-behandelaars van het besluit',
  'hr-besluit.behandelaars+directie': 'HR-behandelaars van het besluit en de directie',
  'hr-besluit.behandelaars+salaris': 'HR-behandelaars van het besluit en de salarisadministratie',
  'hr-besluit.controleurs': 'Controleurs van het besluit (vier ogen)',
  'hr-besluit.stap-verantwoordelijke': 'Verantwoordelijke van de stap',
  'middel.overdracht-ontvanger': 'De ontvanger van de overdracht',
  'reparatie.goedkeurders': 'Goedkeurders van reparatieverzoeken',
  // De stream taken-engine brengt hiervoor zelf een naam mee in notification-rules.ts
  // (die wint); deze staat er voor het geval die regel bij de merge wegvalt.
  'taak.deadline-escalatie': 'De aanmaker van de taak (anders de escalatie-ontvanger van de takenmodule)',
  // batch-68 controle (FO-342 §7)
  'payroll.approvers': 'Wie de verloning accordeert (Payroll goedkeuren)',
  // batch-69 bestelflow (FO-512)
  'uitrusting.beoordelaars': 'Beoordelaars van uitrustingbestellingen',
  'uitrusting.goedkeurder': 'Wie deze bestelling goedkeurde',
  // batch-69 planbord-afspraak (FO-523)
  'afspraak.deelnemers': 'De deelnemers aan de afspraak met de klant',
  'afspraak.escalatie': 'De teamleider van de deelnemers en de accountmanager van de klant',
  // batch-69 actiepunten (FO-514)
  'actiepunt.verantwoordelijke': 'De verantwoordelijke van het actiepunt (toegewezen persoon of de rol)',
  'actiepunten.samenvatting': 'De directie, en bij nieuwe punten ook de rollen die ze kregen',
  // batch-70 app-dashboard (FO-526)
  'app-dashboard.doelgroep': 'De doelgroep App dashboard (de beheerders plus de ontvangers van "Nieuwe versie live")',
}
